/**
 * The simple component rendering navigation buttons
 */

//libraries
import React from "react";
import { useLocation } from "react-router-dom";

//styles
import { FooterLink } from "../../../styles/styles";


const FooterNavButtonComponent = ({ to, label, icon, activeIcon, isCentral }) => {

    const location = useLocation();
    const isActive = (() => {
        // Special case: explore menu item should be active for both /explore and /explore/* (articles)
        if (to === '/explore') {
            return location.pathname === '/explore' || location.pathname.startsWith('/explore/');
        }
        return location.pathname === to;
    })();

    return (
        <FooterLink to={to} className={isActive ? "active" : ""} $iscentral={isCentral}>
            <img src={isActive ? activeIcon : icon} alt="" loading="eager" />
            {!isCentral && <span>{label}</span>}
        </FooterLink>
    );
};

const FooterNavButton = React.memo(FooterNavButtonComponent);

export default FooterNavButton;
